import { CommonModule } from '@angular/common';
import { Component, Input, ElementRef, AfterViewInit, HostListener, OnInit, OnDestroy, ChangeDetectorRef, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subject, fromEvent } from 'rxjs';
import { throttleTime } from 'rxjs/operators';

@Component({
  standalone:true,
  imports:[CommonModule],
  selector: 'app-read-more',
  templateUrl: './read-more.component.html',
  styleUrls: ['./read-more.component.scss']
})
export class ReadMoreComponent implements OnInit, AfterViewInit, OnDestroy {
  destroyRef = inject(DestroyRef)
  // the text that need to be put in the container
  @Input() text: any;
  @Input() options: any;
  @Input() textColor: string;
  @Input() classes: string;

  // set these to false to get the height of the expended container
  public isCollapsed: boolean = false;
  public isCollapsable: boolean = false;

  public webkitLineClampList = [];

  constructor(
    private elementRef: ElementRef,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    const { options } = this;
    const sizes = ['' , 'sm-', 'md-', 'lg-', 'xl-'];

    let webkitLineClampList = options && options.webkitLineClamp ? options.webkitLineClamp: [2,3,3,5,5];
    this.webkitLineClampList = webkitLineClampList.map((lines, index) => {
        return `webkit-line-clamp-${sizes[index]}${lines}`;
    });

    const observeDOM = this.observeDOM();
    observeDOM(document.body, this.observeDOMCallback);

    fromEvent(window, 'resize').pipe(
      throttleTime(300), // emits once, then ignores subsequent emissions for 300ms, repeat...
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      const $ = window['$'];
      const list = $(".description--toggle");
      for(let element of list) {
          const parent = element.parentElement;
          const child = parent.children[0];
  
          child.clientHeight < child.scrollHeight ? $(element).show(): $(element).hide();
      }
    });

    document.body.addEventListener('click', this.onToggle, { capture: true });
  }

  ngAfterViewInit() {
  }

  ngOnDestroy(): void {
    document.body.removeEventListener('DOMNodeInserted', this.observeDOMCallback);
    document.body.removeEventListener('DOMNodeRemoved', this.observeDOMCallback);

    document.body.removeEventListener('click', this.onToggle);
  }

  onToggle(e):void {
    const $ = window['$']
    const { target } = e;
    if(!$(target).hasClass("description--toggle")) {
        return;
    }
    e.stopPropagation();

    const blockClass = `d-block`;
    const webkitBoxClass = `d-webkit-box`;
    const parent = target.parentElement;

    const $child = $(parent.children[1]);

    $child.toggleClass(webkitBoxClass).toggleClass(blockClass);
    $(target).toggleClass("description--more").toggleClass("description--less");
  }

  observeDOM() {
    var MutationObserver = window.MutationObserver || window['WebKitMutationObserver'];
  
    return function( obj, callback ){
      if( !obj || obj.nodeType !== 1 ) return; 
  
      if( MutationObserver ){
        // define a new observer
        var mutationObserver = new MutationObserver(callback)
  
        // have the observer observe for changes in children
        mutationObserver.observe( obj, { childList:true, subtree:true })
        return mutationObserver
      }
      
      // browser support fallback
      else if( window.addEventListener ){
        obj.addEventListener('DOMNodeInserted', callback, false)
        obj.addEventListener('DOMNodeRemoved', callback, false)
      }
    }
  }

  observeDOMCallback(e) {
    const $ = window['$'];
    var addedNodes = [], removedNodes = [];
    e.forEach(record => record.addedNodes.length & addedNodes.push(...record.addedNodes))
    e.forEach(record => record.removedNodes.length & removedNodes.push(...record.removedNodes))
    if(addedNodes.length < 1 && removedNodes.length < 1) {
        return;
    }

    const list = $(".description--toggle");
    for(let element of list) {
        if($(element).hasClass('description--less')) {
            continue;
        }

        const parent = element.parentElement;
        const child = parent.children[0];

        child.clientHeight < child.scrollHeight ? $(element).show(): $(element).hide();
    }
  }
}
